// extracted by mini-css-extract-plugin
module.exports = {"markdown":"text-only_markdown__YTK2V","checkmarkList":"text-only_checkmarkList___vTrd","accentArrowList":"text-only_accentArrowList__azjK7"};